import { formatCompetitor } from '@/app/competitive/utils';
import { useCompetitiveStore } from '@/stores/competitive';
import { useTrackingStore } from '@/stores/tracking';

export const FILTER_ACTION_TYPES = {
  OPENED: 'Opened',
  CLOSED: 'Closed',
  APPLY: 'Apply',
  REMOVE: 'Remove',
  RESET_FILTERSET: 'Reset Filterset',
  RESET_ALL: 'Reset All',
  COLLAPSE: 'Collapse',
  EXPAND: 'Expand',
};

export function trackFilterDrawerInteraction({ action, filterName, selectedOptions }) {
  const trackingStore = useTrackingStore();
  trackingStore.track('Filter Drawer Interaction', {
    action,
    filterName,
    selectedOptions,
  });
}

export function trackCompetitiveMentionsFilter({ updatedFilterKey, currentFilters, routeName }) {
  const trackingStore = useTrackingStore();
  const competitiveStore = useCompetitiveStore();

  if (updatedFilterKey !== 'hasMentionedCompetitor' && updatedFilterKey !== 'competitiveMentions') {
    return;
  }

  const isDiscovery = routeName?.includes('creators.discovery.instagram');

  if (currentFilters.competitiveMentionsFilterType === 'competitors') {
    const selectedCompetitorIds = currentFilters.competitiveMentions || [];
    const hasMentionedValue = currentFilters.hasMentionedCompetitor || [];

    // only trigger if both filters have values and only one mention option is selected
    if (selectedCompetitorIds.length > 0 && hasMentionedValue.length === 1) {
      const selectedCompetitorHandles = selectedCompetitorIds.map((competitorId) => {
        const competitor = competitiveStore.competitiveSegments.find(
          (c) => c.targetSourceId === competitorId,
        );
        if (competitor?.sourceData) {
          return formatCompetitor(competitor.sourceData, competitor.targetSource).handle;
        }
        return competitorId;
      });

      const isHasMentioned = hasMentionedValue.includes('MENTIONED');
      const eventSuffix = isHasMentioned ? 'Has Mentioned' : 'Has Not Mentioned';
      const pageContext = isDiscovery ? 'IG Discovery' : 'Your Creators';

      trackingStore.track(
        `Clicked on ${eventSuffix} Competitors (Apply) in Competitive Mentions filter (${pageContext})`,
        {
          selectedCompetitors: selectedCompetitorHandles,
          hasMentionedValue,
        },
      );
    }
  } else if (currentFilters.competitiveMentionsFilterType === 'competitorTags') {
    const selectedTags = currentFilters.competitiveMentions || [];

    if (selectedTags.length > 0) {
      const tagDetails = selectedTags.map((tagId) => {
        const tag = competitiveStore.activeCompetitorTags.find((t) => t.id === tagId);
        return {
          tagName: tag.name,
          tagId: tag.id,
        };
      });

      const pageContext = isDiscovery ? 'IG Discovery' : 'Your Creators';

      trackingStore.track(
        `Clicked on a Competitor tag in the Competitive Mentions filter (${pageContext})`,
        {
          selectedTags: tagDetails,
          totalSelected: selectedTags.length,
        },
      );
    }
  }
}
